// Web implementation of SoundPlayer using HTML5 Audio API
let currentAudio = null;

// Pre-load audio files using require for proper bundling
const audioFiles = {
  f16: require('../resources/mp3/f16.mp3'),
  mq9: require('../resources/mp3/mq9.mp3'),
};

const SoundPlayer = {
  playSoundFile: (name, ext) => {
    try {
      // Stop any currently playing audio
      SoundPlayer.stop();

      // Get the audio file path from the pre-loaded files
      const audioPath = audioFiles[name];

      if (!audioPath) {
        console.warn(`Sound file not found: ${name}.${ext}`);
        return;
      }

      // Create new audio instance with the bundled file
      currentAudio = new Audio(audioPath);

      // Play the audio
      currentAudio.play().catch((error) => {
        console.warn('Error playing sound:', error);
      });
    } catch (error) {
      console.warn('Error loading sound file:', error);
    }
  },

  stop: () => {
    if (currentAudio) {
      currentAudio.pause();
      currentAudio.currentTime = 0;
      currentAudio = null;
    }
  },
};

export default SoundPlayer;
